<form [formGroup]="addressForm" class="sectionBlock">
    <div class="row p-4">
        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
                <div class="mb-3"><strong>House/Building/Flat/Landmark</strong><span class="formMandatoryInput">*</span>
                </div>
                <input type="text" class="form-control" placeholder="House/Building/Flat/Landmark"
                    formControlName="localityAdress">
                <div *ngIf="Submitted && f['localityAdress'].errors" class="formMandatoryInput"
                    style="font-size: 12px;">House/Building/Flat/Landmark is Reqiured</div>
            </div>
        </div>
        <!-- Show state only if it intended to show from parent -->
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="adressMetaData?.location?.showState || adressMetaData?.location?.showState == null">
            <div class="form-group">
                <label><strong>State</strong><span class="formMandatoryInput">*</span></label>
                <ng-select [(ngModel)]="selectedState" formControlName="state" (change)="getDistrict(true)">
                    <ng-option value="">Select State</ng-option>
                    <ng-option *ngFor="let state of states" [value]="state">{{ state?.name }}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['state'].errors" class="formMandatoryInput" style="font-size: 12px;">State is
                    Reqiured</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="adressMetaData?.location?.showDistrict || adressMetaData?.location?.showDistrict == null">
            <div class="form-group">
                <label><strong>District</strong><span class="formMandatoryInput">*</span></label>
                <ng-select [(ngModel)]="selectedDistrict" formControlName="district" (change)="getCities(true)">
                    <ng-option value="">Select District</ng-option>
                    <ng-option *ngFor="let district of districts" [value]="district">{{ district?.name }}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['district'].errors" class="formMandatoryInput" style="font-size: 12px;">
                    District is Reqiured</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="adressMetaData?.location?.showCity || adressMetaData?.location?.showCity == null">
            <div class="form-group">
                <label><strong>City</strong><span class="formMandatoryInput">*</span></label>
                <ng-select [(ngModel)]="selectedCity" formControlName="city">
                    <ng-option value="">Select City</ng-option>
                    <ng-option *ngFor="let city of cityList" [value]="city">{{ city?.name }}</ng-option>
                </ng-select>
                <div *ngIf="Submitted && f['cityId'].errors" class="formMandatoryInput" style="font-size: 12px;">City is
                    Reqiured</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="adressMetaData?.location?.showTehsil || adressMetaData?.location?.showTehsil == null">
            <div class="form-group">
                <label><strong>Tehsil</strong></label>
                <select class="form-control" formControlName="tehsil">
                    <option class="form-control" value="">Select Tehsil</option>
                </select>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
            *ngIf="adressMetaData?.location?.showVillage || adressMetaData?.location?.showVillage == null">
            <div class="form-group">
                <label><strong>Village</strong></label>
                <select class="form-control" formControlName="village">
                    <option class="form-control" value="">Select Village</option>
                </select>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
            <div class="form-group">
                <label><strong>Pin Code</strong><span class="formMandatoryInput">*</span></label>
                <input type="text" class="form-control" inputmode="numeric" maxlength="6"
                    (mouseleave)="onMouseLeavefromLastInput()" placeholder="Pincode" formControlName="pincode">
                <div *ngIf="Submitted && f['pincode'].errors" class="formMandatoryInput" style="font-size: 12px;">
                    Pincode is Reqiured</div>
            </div>
        </div>
        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <label><strong>Full Address :</strong></label>
            <span class="fullAddress">{{adressMetaData?.fullAdress}}</span>
        </div>
    </div>
    <div class="col-sm-12 mb-5">
        <button type="button" class="btn btn-danger" (click)="close()">Close</button>
        <button type="submit" class="btn btn-success mr-2" (click)="onSubmit()">Submit</button>
    </div>
</form>